// src/lib/opportunity/formatSettingsClient.ts

import { opportunityFetch } from "./opportunityFetch";
import type { OpportunityFormatKey } from "@/types/opportunity";
import type { FormatSettings } from "./formatSettingsTypes";

export function getFormatSettings(filters: {
  format_key: OpportunityFormatKey;
  product_type: string;
}) {
  const q = new URLSearchParams({
    format_key: filters.format_key,
    product_type: filters.product_type,
  });
  return opportunityFetch<{ ok: true; settings: FormatSettings | null }>(
    `/api/opportunity/format-settings-get?${q.toString()}`,
    { method: "GET" },
  );
}

export function upsertFormatSettings(payload: {
  format_key: OpportunityFormatKey;
  product_type: string;
  base_amount_label: string;
}) {
  return opportunityFetch<{ ok: true; settings: FormatSettings }>(
    "/api/opportunity/format-settings-upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}
